export default __webpack_public_path__ + "static/media/EM0630.34I-22025_-15011_0.1c3580f6.jpg";